<template>
  <div class="box-shadow">    
  <form>
    <div class="col-sm-12">
      <h4 class="heading">Basic Details</h4>
      <div class="row">
        <div class="col-sm-4 form-group">
          <label>Contract Note : &nbsp;&nbsp;</label><span>{{formInput.contract_note}}</span>
        </div>    
        <div class="col-sm-4 form-group">
          <label>Ticket Number : &nbsp;&nbsp;</label><span>{{formInput.ticket_number}}</span>
        </div>  
        <div class="col-sm-4 form-group">
          <label>Broker : &nbsp;&nbsp;</label><span>{{brokers ? brokers[formInput.broker_id].name : '-'}}</span>
        </div>
      </div>   
      <div v-if="!bulk">
        <h4 class="heading">Account Details</h4>
        <div class="row">
          <div class="col-sm-4 form-group">
            <label>Account Number</label><span>{{formInput.account_detail[0].account_number}}</span>
          </div>    
          <div class="col-sm-4 form-group">
            <label>Client Name</label><span>{{formInput.account_detail[0].client_name}}</span>
          </div> 
        </div> 
      </div>
      <div>
        <div>
          <h4 class="heading">Trade Details</h4>
          <div class="row">
            <div class="col-sm-4 form-group">
              <label>Ticker : &nbsp;&nbsp;</label><span>{{formInput.stock.tidm}}</span>
            </div>
            <div class="col-sm-4 form-group">
              <label>Security Name : &nbsp;&nbsp;</label><span>{{formInput.stock.issuer_name}}</span>
            </div>
            <div class="col-sm-4 form-group">
              <label>Security ID : &nbsp;&nbsp;</label><span>{{formInput.stock.isin}}</span>
            </div>
            <!--<div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.security_fee')}">
              <label>SECFee (in %)</label><span class="message">{{ validation.firstError('formInput.security_fee') }}</span>
              <input type="text" placeholder="Enter SECFee hear.." class="form-control" v-model="formInput.security_fee">
            </div>-->
            <div class="col-sm-4 form-group">
              <label>Side/Type : &nbsp;&nbsp;</label><span>{{formInput.type}}</span>
            </div>
            <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.total_quantity')}">
              <label>Total Quantity : &nbsp;&nbsp;</label><span>{{formInput.total_quantity}}</span>
            </div>
            <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.stock.currency')}">
              <label>Currency/LCY : &nbsp;&nbsp;</label><span>{{formInput.contract_note}}</span>
              <!--<select name="currency" ref="currency" class="form-control" v-model="formInput.stock.currency">
                <option selected value="">Select Currency</option>
                <option v-for="cur in currencies" :value="cur.code" :key="cur.id">{{cur.name+' ('+cur.code+')'}}</option>
              </select>-->
              <!--<input type="text" ref="currency" placeholder="Enter Currency Here.." class="form-control" v-model="formInput.stock.currency">-->
            </div>
            <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.trade_price')}">
              <label>Trade Price</label><span>{{formInput.contract_note}}</span>
              <input type="text" ref="trade_price" placeholder="Enter Trade Price Here.." class="form-control" v-model="formInput.trade_price" @input="calc_value">
            </div>
            <!--<div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.market_price')}">
              <label>Market Price</label><span class="message">{{ validation.firstError('formInput.market_price') }}</span>
              <input type="text" ref="market_price" placeholder="Enter Market Price Here.." class="form-control" v-model="formInput.market_price">
            </div>-->
            <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.trade_plus')}">
              <label>Trade +</label><span>{{formInput.contract_note}}</span>
              <b-input-group>
                <template v-slot:prepend>
                  <b-input-group-text >T+</b-input-group-text>
                </template>
                <input type="number" ref="trade_plus" placeholder="Enter Trade+ Here.." class="form-control" v-model="formInput.trade_plus">
              </b-input-group>
            </div>
            <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.trade_date')}">
              <label>Trade Date (DD-MM-YYYY HH:mm)</label><span>{{formInput.contract_note}}</span>
              <date-picker v-if="(!can_access('deal_second_step_before_approval','modify') && !formInput.approved_at)||(formInput.action=='created'||formInput.action=='sub_deal')" input-class="form-control" ref="trade_date" value-type="format" type="datetime" v-model="formInput.trade_date" format='DD-MM-YYYY HH:mm'></date-picker>
              <input v-else type="text" placeholder="Enter Trade Date and Time Here.." class="form-control" v-model="formInput.trade_date" readonly>
            </div>
            <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.settlement_date')}">
              <label>Settlement Date (DD-MM-YYYY)</label><span>{{formInput.contract_note}}</span>
              <date-picker input-class="form-control" ref="settlement_date" value-type="format" v-model="formInput.settlement_date" format='DD-MM-YYYY'></date-picker>
              <!--<input type="text" placeholder="Enter Settlement Date Here.." class="form-control" v-model="formInput.settlement_date">-->
            </div>
            <div class="col-sm-4 form-group">
              <label for="notes">Notes</label><span>{{formInput.contract_note}}</span>
              <textarea class="form-control" id="notes" v-model="formInput.notes" rows="2"></textarea>
            </div>
            <!--<div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.trade_time')}">
              <label>Time Of Trade (HH:mm)</label><span class="message">{{ validation.firstError('formInput.trade_time') }}</span><br>
              <date-picker input-class="form-control" ref="trade_time" type="time" v-model="formInput.trade_time" value-type="format" format='HH:mm'></date-picker>
              <input type="text" placeholder="Enter Time Of Trade Here.." class="form-control" v-model="formInput.trade_time">
            </div>-->
          </div>
        </div>
        <div v-if="can_access('deal_second_step_before_approval','modify')">
          <h4 class="heading">Fees &amp; Charges</h4>
          <div class="row">
            <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.commission_value')}">
              <label>Commission</label><span class="message">{{ validation.firstError('formInput.commission_value') }}</span>
              <div class="input-group"> 
                  <select class="form-control w-40" v-model="formInput.commission_type" @change="calc_value">
                      <option value="0">Percentage</option>
                      <option value="1">Fixed Value</option>
                      <option value="2">Value Per Quantity</option>
                  </select>
                  <input type="number" v-model="formInput.commission_rate" :max="formInput.commission_type=='0'?'5':'30'" min="0" class="form-control w-60" @input="calc_value"/>
              </div>
            </div>
            <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.stamp_duty_value')}">
              <label>Stamp Duty <span v-if="formInput.stamp_duty_excemption" style="color:green">(Exemption Available)</span></label><span class="message">{{ validation.firstError('formInput.stamp_duty_value') }}</span>
              <div class="input-group"> 
                  <select class="form-control w-40" v-model="formInput.stamp_duty_type" @change="calc_value">
                      <option value="0">Percentage</option>
                      <option value="1">Fixed Value</option>
                      <option value="2">Value Per Quantity</option>
                  </select>
                  <input type="number" v-model="formInput.stamp_duty_rate" :max="formInput.stamp_duty_type=='0'?'5':'30'" min="0" class="form-control w-60" @input="calc_value"/>
              </div>
            </div>
            <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.fees_value')}">
              <label>Fees</label><span class="message">{{ validation.firstError('formInput.fees_value') }}</span>
              <div class="input-group"> 
                  <select class="form-control w-40" v-model="formInput.fees_type" @change="calc_value">
                      <option value="0">Percentage</option>
                      <option value="1">Fixed Value</option>
                      <option value="2">Value Per Quantity</option>
                  </select>
                  <input type="number" v-model="formInput.fees_rate" :max="formInput.fees_type=='0'?'5':'30'" min="0" class="form-control w-60" @input="calc_value"/>
              </div>
            </div>
            <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.other_levy_value')}">
              <label>Other Levy</label><span class="message">{{ validation.firstError('formInput.other_levy_value') }}</span>
              <div class="input-group"> 
                  <select class="form-control w-40" v-model="formInput.other_levy_type" @change="calc_value">
                      <option value="0">Percentage</option>
                      <option value="1">Fixed Value</option>
                      <option value="2">Value Per Quantity</option>
                  </select>
                  <input type="number" v-model="formInput.other_levy_rate" :max="formInput.other_levy_type=='0'?'5':'30'" min="0" class="form-control w-60" @input="calc_value"/>
              </div>
            </div>
            <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.other_taxes_value')}">
              <label>Other Taxes</label><span class="message">{{ validation.firstError('formInput.other_taxes_value') }}</span>
              <div class="input-group"> 
                  <select class="form-control w-40" v-model="formInput.other_taxes_type" @change="calc_value">
                      <option value="0">Percentage</option>
                      <option value="1">Fixed Value</option>
                      <option value="2">Value Per Quantity</option>
                  </select>
                  <input type="number" v-model="formInput.other_taxes_rate" :max="formInput.other_taxes_type=='0'?'5':'30'" min="0" class="form-control w-60" @input="calc_value"/>
              </div>
            </div>
            <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.other_fees_and_charges_value')}">
              <label>Other Fees &amp; Charges</label><span class="message">{{ validation.firstError('formInput.other_fees_and_charges_value') }}</span>
              <div class="input-group"> 
                  <select class="form-control w-40" v-model="formInput.other_fees_and_charges_type" @change="calc_value">
                      <option value="0">Percentage</option>
                      <option value="1">Fixed Value</option>
                      <option value="2">Value Per Quantity</option>
                  </select>
                  <input type="number" v-model="formInput.other_fees_and_charges_rate" :max="formInput.other_fees_and_charges_type=='0'?'5':'30'" min="0" class="form-control w-60" @input="calc_value"/>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-4">
          <div class="row">
            <div class="col-sm-4 form-group form-check">
              <input type="checkbox" class="form-check-input" id="bulk" v-model="bulk">
              <label class="form-check-label" for="bulk">Bulk</label>
            </div>
          </div>
          <div v-if="bulk">
            <div class="row"  v-for="(account, index) in formInput.account_detail" :key="account.id">
              <div class="col-lg-12 text-right"><i class="fa fa-close" @click="removeElement(index)"></i></div>
              <AddBulkCustomer :row="account" @accountnumber="(newValue) => formInput.account_detail[index].account_number=newValue" @clientname="(newValue) => formInput.account_detail[index].client_name=newValue" @quantity="(newValue) => formInput.account_detail[index].quantity=newValue" ref="account_detail"/>
            </div> 
            <a href="javascript:;" class="pull-right" @click="addRow"><span v-if="bulkError" class="message" style="color:red">{{bulkError}} </span>Add New Account</a><br>
          </div>
        </div>
      </div>
      <div v-if="can_access('deal_second_step_before_approval','modify')">
        <div class="row" v-if="formInput.trade_price&&formInput.total_quantity">
          <div class="col-md-12">
            <hr>
            <dl class="dl-horizontal" style="float:right">
                <dt>Trade Value : ({{formInput.stock.currency}})</dt> <dd>{{formInput.trade_value}}</dd>
                <!--<dt>Market Value : ({{formInput.stock.currency}})</dt> <dd>{{formInput.market_value ? formInput.market_value : '-'}}</dd>-->
                <dt>Exchange Fees/PTMLevy : ({{formInput.stock.currency}})</dt> <dd>{{formInput.exchange_fee||'0'}}</dd>
                <dt>Commission : ({{formInput.commission_type == 0 ? formInput.commission_rate+'%' : 'Value: '+formInput.commission_rate}})</dt><dd>{{formInput.commission_value || "0"}}</dd>
                <dt>Stamp Duty Value : ({{formInput.stamp_duty_type == 0 ? formInput.stamp_duty_rate+'%' : 'Value: '+formInput.stamp_duty_rate}})</dt><dd>{{formInput.stamp_duty_value || "0"}}</dd>
                <dt>Fees : ({{formInput.fees_type == 0 ? formInput.fees_rate+'%' : 'Value: '+formInput.fees_rate}})</dt><dd>{{formInput.fees_value || "0"}}</dd>
                <dt>Other Levy : ({{formInput.other_levy_type == 0 ? formInput.other_levy_rate+'%' : 'Value: '+formInput.other_levy_rate}})</dt><dd>{{formInput.other_levy_value || "0"}}</dd>
                <dt>Other Taxes : ({{formInput.other_taxes_type == 0 ? formInput.other_taxes_rate+'%' : 'Value: '+formInput.other_taxes_rate}})</dt><dd>{{formInput.other_taxes_value || "0"}}</dd>
                <dt>Other Fees &amp; Charges : ({{formInput.other_fees_and_charges_type == 0 ? formInput.other_fees_and_charges_rate+'%' : 'Value: '+formInput.other_fees_and_charges_rate}})</dt><dd>{{formInput.other_fees_and_charges_value || "0"}}</dd>                
                <!--<dt>Charges Value : ({{formInput.charges_basis}}%)</dt> <dd>{{formInput.charges_value}}</dd>-->
                <dt>Total Charges : ({{formInput.stock.currency}})</dt> <dd>{{formInput.total_other_charges  || 0}}</dd>
                <dt>Total Consideration : ({{formInput.stock.currency}})</dt> <dd>{{formInput.total_consideration || 0}}</dd>
            </dl>
          </div> 
        </div>
      </div>
      <input type="hidden" v-model="formInput.id"/>
      <div class="mt-4" style="display:flow-root">
        <button type="button" v-on:click="addTrade" class="btn btn-lg btn-info pull-right">Submit</button>
      </div>       
    </div>
  </form>
  <b-modal ref="add-securities-out" title="Add Security" size="xl" hide-footer v-if="showAddSecurityForm && can_access('security','modify')">
    <p class="my-4"><AddSecurityForm :forceRerender="securityFormReRender"/></p>
  </b-modal>

  <b-modal ref="upload-deal-ticket-out" title="Upload Deal Ticket" size="xl" hide-footer v-if="showUploadDealTicketForm && can_access('deal','upload')">
    <p class="my-4"><UploadDealTicketForm :forceRerender="uploadDealTicketFormReRender"/></p>
  </b-modal>
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import common from '@/assets/js/common.js';
import AddSecurityForm from '@/components/Accounts/AddSecurityForm';
import UploadDealTicketForm from '@/components/Accounts/UploadTradesCSV';
import AddBulkCustomer from '@/components/Accounts/AddBulkCustomer'
import DatePicker from 'vue2-datepicker';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import 'vue-material/dist/vue-material.css';
import moment from 'moment';
import 'vue2-datepicker/index.css';
import SimpleVueValidator from 'simple-vue-validator';

const Validator = SimpleVueValidator.Validator;
export default {
  name: 'AddCustomerForm',
  props:['rows', 'forceRerender'],
  mixins: [common,SimpleVueValidator.mixin],
  components: {DatePicker, VueBootstrapTypeahead, AddSecurityForm,UploadDealTicketForm, AddBulkCustomer},
  data(){
    return {
      customers: [],
      instruments: [],
      brokers: [],
      showDetailedForm: false,
      showUploadDealTicketForm: true,
      showAddSecurityForm: true,
      lessOrMore: "more",
      bulk:0,
      currencies: [],
      bulkError: '',
      bulkId : 1,
      formInput:{
        'id':'',
        'action': 'sub_deal',
        'count': 0,
        'contract_note': '',
        'ticket_number': '',
        'account_detail' : [{
          'id':1,
          'account_number': '',
          'client_name': '',
          'quantity': '',
        }],
        'broker_id': '1',
        'lse_id': '',
        'security_fee': '1',
        'type': 'BUY',
        'total_quantity' : '',
        'trade_price': '',
        'market_price': '',
        'trade_plus': '20',
        'trade_date': moment().format('DD-MM-YYYY HH:mm'),
        'settlement_date': '',
        'trade_time': moment().format('HH:mm'),
        'trade_value': '',
        'market_value': '',
        'notes': '',
        'stamp_duty_rate': 0,
        'stamp_duty_value': '',
        'stamp_duty_type': '0',
        'charges_basis': 1,
        'charges_value': this.axcap_charges + this.broker_charges,
        'exchange_fee': 0,
        'total_other_charges': '',
        'total_consideration': '',
        'commission_rate' : 1,
        'commission_value' : '',
        'commission_type': '0',
        'status': 1,
        'fees_rate' : 0,
        'fees_value' : '',
        'fees_type': '0',
        'other_levy_rate' : 0,
        'other_levy_value' : '',
        'other_levy_type': '0',
        'other_taxes_rate' : 0,
        'other_taxes_value' : '',
        'other_taxes_type': '0',
        'other_fees_and_charges_rate' : 0,
        'other_fees_and_charges_value' : '',
        'other_fees_and_charges_type': '0',
        'stamp_duty_excemption': 0,
        'stock': {
          'issuer_name': '',
          'isin': '',
          'tidm': '',
          'currency': '',
          'stamp_duty_exemption_start_date' : '',
          'stamp_duty_exemption_end_date': ''
        }
      }
    };
  },
  computed: {
    authHeaders () {
      return {
        'access-token': '7403f0291437c47e589fdd0445860f95'
      }
    },
  },
  validators: {
    'formInput.account_detail.0.account_number': function(value) {
      var bulk = this.bulk;
      return Validator.value(value).custom(function(){
        if(!bulk && !value) return "Required";  
      });
    },
    'formInput.client_name': function(value) {
      return Validator.value(value);
    },
    'formInput.stock.tidm': function(value) {
      var type = this.formInput.type;
      return Validator.custom(function () {
        if (["BUY","SELL","FX"].indexOf(type)>=0 && !value) {
          return "Required";
        }
      });
    },
    'formInput.stock.issuer_name': function(value) {
      return Validator.value(value);
    },
    'formInput.stock.isin': function(value) {
      return Validator.value(value);
    },
    'formInput.type': function(value) {
      return Validator.value(value).required();
    },
    'formInput.total_quantity': function(value) {
      return Validator.value(value).required().integer();
    }, 
    /* 'formInput.quantity': function(value) {
      return Validator.value(value).required().integer();
    }, */
    'formInput.stock.currency': function(value) {
      return Validator.value(value).required();
    },
    'formInput.trade_price': function(value) {
      return Validator.value(value).required().float();
    },
    'formInput.trade_plus': function(value) {
      return Validator.value(value).required().integer();
    },
    'formInput.trade_date': function(value) {
      return Validator.value(value).required().regex('^((0[1-9]|[12]\\d|3[01])-(0[1-9]|1[0-2])-([12]\\d{3})\\s((0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])(:00)?))$', 'Not in Valid Format: DD-MM-YYYY HH:mm.');
    },
    'formInput.settlement_date': function(value) {
      return Validator.value(value).required().regex('^((0[1-9]|[12]\\d|3[01])-(0[1-9]|1[0-2])-([12]\\d{3}))$', 'Not in Valid Format: DD-MM-YYYY.');
    },
    /*'formInput.trade_time': function(value) {
      return Validator.value(value).required().regex('^((0[1-9]|1[0-9]|2[0-4]):([0-5][0-9])(:00)?)$', 'Not in Valid Format: HH:mm.');
    },
    'formInput.security_fee': function(value) {
      return Validator.value(value).required().integer().between(0,100);
    },*/
    'formInput.stamp_duty_rate': function(value) {
      return Validator.value(value).float();
    }
  },
  watch: {
    'formInput.stock.tidm': function (input) {
      this.$refs.tidm.inputValue = input;
      this.getInstrumentByTicker(input);
    },
    'formInput.stock.currency': function (input) {
      this.$refs.currency.inputValue = input;
    },
    'formInput.stock': {
      handler:function(value) {
        this.stampDutyExcemptionChecker();
      },
      deep : true,
    },
    'formInput.trade_date': function(value){
      this.stampDutyExcemptionChecker();
    },
    'formInput.id': function(){
      if(this.formInput.status == 0) this.addTrade();
    },
    'formInput.account_detail': function (value) {
      if(value.length>1) this.bulk = 1;
      else this.$refs["account_number_0"].inputValue = value[0].account_number;
    },
    bulk: function (input){
      if(!bulk){
        this.bulkId = 1;
        this.account_detail = [{
          'id': this.bulkId,
          'account_number': '',
          'client_name': '',
          'quantity':''
        }];
      }
    }
  },
  methods: {
    async getCustomer(input) {
      const limit = 10, offset = 0, sort = '', order = '';
      var filter = {'approved_at':{from_date:'2020-01-01'}}; 
      filter['account_number'] = input;
      let uri = 'customer_list?limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter);
      const {response} = await this.call_axios(uri);
      this.customers = response.data.result;
    },
    setCustomerInfo (group,index) {
      this.$refs["account_number_0"].inputValue = group.account_number;
      this.formInput.account_detail[index].account_number = group.account_number;
      this.formInput.account_detail[index].client_name = (typeof group == "object") ? group.firstname+' '+(group.lastname ? group.lastname : "") : "" ;
      // access the autocomplete component methods from the parent
      //this.$refs.account_number.clear()
    },
    customerFormattedDisplay (result) {
      return result.account_number+" ( "+result.firstname+""+(result.lastname?" "+result.lastname:"")+" )";
    },
    async getInstrumentByTicker (input) {
      const limit = 10, offset = 0, sort = '', order = '';
      var filter = {}; 
      filter['tidm'] = input;
      var uri = 'stock_list?limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter);
      const {response} = await this.call_axios(uri);
      this.instruments = response.data.result;
    },
    setInstrumentInfo (group) {
      this.formInput.stock.tidm = (typeof group == "object") ? group.tidm : group;
      this.$refs.tidm.inputValue = (typeof group == "object") ? group.tidm : group;
      this.formInput.lse_id = (typeof group == "object") ? group.id : "";
      this.formInput.stock.issuer_name = (typeof group == "object") ? group.issuer_name : "";
      this.formInput.stock.isin = (typeof group == "object") ? group.isin : "";
      this.formInput.stock.currency = (typeof group == "object") ? group.currency : "";
      this.formInput.stock.stamp_duty_exemption_start_date = (typeof group == "object") ? group.stamp_duty_exemption_start_date : "";
      this.formInput.stock.stamp_duty_exemption_end_date = (typeof group == "object") ? group.stamp_duty_exemption_end_date : "";
      // access the autocomplete component methods from the parent
      //this.$refs.account_number.clear()
    },
    InstrumentFormattedDisplay (result) {
      return result.tidm+" ("+result.issuer_name+", "+result.issuer_name+")";
    },
    CurrencyFormattedDisplay (result) {
      return result.name+' ('+result.code+')';
    },
    setCurrencyInfo (group) {
      this.formInput.stock.currency = (typeof group == "object") ? group.code : group;
      this.$refs.currency.inputValue = (typeof group == "object") ? group.code : group;
    },
    setShowDetailedForm: function(e){
      e.preventDefault();
      this.showDetailedForm = this.showDetailedForm?false:true;
      this.lessOrMore = this.showDetailedForm?"less":"more";
    },
    calc_value: function(){
      this.formInput.total_other_charges = 0;
      if(this.formInput.trade_price && this.formInput.total_quantity) this.formInput.trade_value = this.formatNumber(this.formInput.trade_price * this.formInput.total_quantity);

      if(this.formInput.market_price && this.formInput.total_quantity) this.formInput.market_value = this.formatNumber(this.formInput.market_price * this.formInput.total_quantity);

      ['commission','stamp_duty','fees','other_levy','other_taxes','other_fees_and_charges'].forEach((val,i) => {
        if(val == 'stamp_duty' && this.formInput.stamp_duty_excemption) this.formInput['stamp_duty_rate'] = 0;

        if(this.formInput[val+'_type'] == 0){
          if(this.formInput[val+'_rate'] > 5) this.formInput[val+'_rate'] = 5;
          else if(this.formInput[val+'_rate'] < 0) this.formInput[val+'_rate'] = 0;
          this.formInput[val+'_value'] = this.formatNumber(parseFloat(this.formInput[val+'_rate'] * (this.formInput.trade_value/100)));
        }

        else if(this.formInput[val+'_type'] == 1 && this.formInput[val+'_rate'] <= 30 && this.formInput[val+'_rate'] >= 0) this.formInput[val+'_value'] = parseFloat(this.formInput[val+'_rate']);

        else if(this.formInput[val+'_type'] == 2 && this.formInput[val+'_rate'] <= 30 && this.formInput[val+'_rate'] >= 0) this.formInput[val+'_value'] = parseFloat(this.formInput[val+'_rate'] * this.formInput.total_quantity);

        else if(this.formInput[val+'_rate'] < 0) this.formInput[val+'_rate'] = 0;
        else{
          this.formInput[val+'_value'] = 0;
          this.formInput[val+'_rate'] = 30;
        }

        this.formInput.total_other_charges += parseFloat(this.formInput[val+'_value']);
      });

      /* if(this.formInput.stamp_duty_rate > 100) this.formInput.stamp_duty_rate = 100;
      else if(this.formInput.stamp_duty_rate < 0) this.formInput.stamp_duty_rate = 0;  */

      if(this.formInput.trade_value){
        this.formInput.exchange_fee = (this.formInput.trade_value >= 10000 && (this.formInput.stock.currency == 'GBP' || this.formInput.stock.currency == 'GBX') && (this.formInput.type == "BUY" || this.formInput.type == "SELL")) ? 1 : 0;

        /* this.formInput.stamp_duty_value = this.formatNumber(this.formInput.trade_value * (this.formInput.stamp_duty_rate/100)); */

        /* this.formInput.total_other_charges = this.formatNumber(this.formInput.stamp_duty_value  + this.formInput.exchange_fee + this.formInput.commission_value); */

        this.formInput.total_other_charges += parseFloat(this.formInput.exchange_fee);

        if(["BUY","FOP IN","TRANSFER IN","FX",'GIVE IN','DVP IN'].indexOf(this.formInput.type)>=0)
          this.formInput.total_consideration = this.formatNumber(this.formInput.trade_value + this.formInput.total_other_charges);
        else
          this.formInput.total_consideration = this.formatNumber(this.formInput.trade_value - this.formInput.total_other_charges);
      }
    },
    stampDutyExcemptionChecker(){
      if(((!this.formInput.stock.stamp_duty_exemption_start_date || moment(this.formInput.trade_date,'DD-MM-YYYY').isSameOrAfter(moment(this.formInput.stock.stamp_duty_exemption_start_date,'DD-MM-YYYY'))) && (!this.formInput.stock.stamp_duty_exemption_end_date || moment(this.formInput.trade_date,'DD-MM-YYYY').isSameOrBefore(moment(this.formInput.stock.stamp_duty_exemption_end_date,'DD-MM-YYYY')))) && (this.formInput.stock.stamp_duty_exemption_start_date || this.formInput.stock.stamp_duty_exemption_end_date)) this.formInput.stamp_duty_excemption = 1;
      else this.formInput.stamp_duty_excemption = 0;

      this.calc_value();
    },
    addTrade(){
      this.$validate()
      .then(async (success) => {
        if (success) {
          Promise
          .all(this.$refs.hasOwnProperty('account_detail')?this.$refs.account_detail.map(function (account) {
            //console.log('sdf',account)
            return account.$validate();
          }):[true])
          .then(async (results) => {
            if (results.filter(function(result) {
                return !result;
              }).length === 0) {
                if(this.bulk)
                  this.bulkValidator(1);
                if(!this.bulkError){
                  const {response} = await this.call_axios('add_trade', 'post', this.formInput);
                  this.forceRerender(response);
                }
            }
          });
        }
      });
      /* this.$validate()
          .then(async (success) => {
            if (success) {
              //console.log(this.$data);return;
              const {response} = await this.call_axios('add_trade', 'post', this.formInput);
              this.forceRerender(response);
            }
          }); */
    },
    async trade_init(){
      const {response} = await this.call_axios('trade_init_data');
      if(!this.formInput.contract_note || !this.formInput.ticket_number){
        this.formInput.contract_note = !this.formInput.contract_note ? response.data.next_contract_note : this.formInput.contract_note;
        this.formInput.ticket_number = !this.formInput.ticket_number ? response.data.next_ticket_number : this.formInput.ticket_number;
      }
      this.currencies = response.data.currencies;
    },
    async getBrokers() {
      let uri = 'brokers';
      const {response} = await this.call_axios(uri);
      this.brokers = response.data.result;
    },
    showModal(model) {
      this.$refs[model].show()
    },
    securityFormReRender(response){
      if(response.code==0){
          this.$refs['add-securities-out'].hide()
          this.$toasted.success("Successfully Added",{duration:1000});
      }
    },
    uploadDealTicketFormReRender(reaponse){
      if(response.code==0){
          this.$refs['upload-deal-ticket-out'].hide()
          this.$toasted.success("Successfully Added",{duration:1000});
      }
    },
    accountNumber(index){
      this.getCustomer();
      this.$refs['account_number_'+index].hasOwnProperty('inputValue')?(this.$refs['account_number_'+index].inputValue = this.formInput.account_detail[index].account_number):(this.$refs['account_number_'+index][0].inputValue = this.formInput.account_detail[index].account_number);
    },

    addRow: function() {
      this.$validate()
          .then(async (success) => {
            if (success) {
              Promise
              .all(this.$refs.account_detail.map(function (account) {
                return account.$validate();
              }))
              .then((results) => {
                if (results.filter(function(result) {
                    return !result;
                  }).length === 0) {
                    this.bulkValidator();
                    if(!this.bulkError){
                      this.bulkId += 1;
                      this.formInput.account_detail.push({
                        id: this.bulkId,
                        'account_number': '',
                        'client_name': '',
                        quantity: ''
                      });
                    }
                }
              });
            }
          });
          //console.log(this.validation)
    },
    removeElement: function(index) {
        this.formInput.account_detail.splice(index, 1);
        //console.log(index,this.formInput.account_detail);
    },
    bulkValidator(submit=0){
      var total_quantity = this.formInput.total_quantity;
      var total_used_quantity = 0;
      var vm = this;
      vm.bulkError = "";
      Object.keys(this.formInput.account_detail).forEach(function(val,i){
        total_used_quantity += parseInt(vm.formInput.account_detail[i].quantity);
      });
      if(parseInt(this.formInput.total_quantity) < parseInt(total_used_quantity)){
        this.bulkError = "Quantity Exceeds!";
      }
      else if(parseInt(this.formInput.total_quantity) == parseInt(total_used_quantity) && !submit){
        this.bulkError = "Can Not Add More Than Total Quantity!";
      }
      else if(parseInt(this.formInput.total_quantity) != parseInt(total_used_quantity) && submit){
        this.bulkError = "Total Sub-quantities Are Not Equal To Total Quantity!";
      }
    }
  },
  mounted(){
    
  },
  created(){
    if(typeof this.rows != 'undefined'){
      Object.assign(this.formInput, this.rows);
    }
    this.trade_init();
    this.getBrokers();
    this.calc_value();
  }
};
</script>

<style lang="scss">
.only-border-bottom{
  border-bottom: 1px solid !important;
  border: 0;
}
.bold{
  font-weight: bold;
}
.error .message{
  color: red;
  padding: 5px 5px;
}
.error .form-control, .error .autocomplete__box{
  border-color: red;
}
.mx-datepicker{
  width: 100%;
}
.heading{
  font-weight:600;
}
.input-group .w-40{
    width:40%;
}
.input-group .w-60{
    width:60%;
}
.vbt-autcomplete-list{
  background-color: #fff;
}
</style>
<style scoped>
.dl-horizontal dd {
    margin-left: 340px;
}
.dl-horizontal dt {
    width: 320px;
}
.input-group > .form-control, .input-group > .form-control-plaintext, .input-group > .custom-select, .input-group > .custom-file{
  flex: min-content;
}
.form-check-label{
  padding-left: 10px !important;
  vertical-align: middle;
  vertical-align: -moz-middle-with-baseline;
}
.form-check{
  padding-left: 30px !important;
}
.form-group label{
  font-weight: 600;
} 
</style>